/**
 * Constants definition.
 *
 * @type {{DRAFT: string, SENT: string, IN_REVIEW: string, REVIEWED: string, VALIDATED: string, ACCEPTED: string, REJECTED: string, ASSIGNED: string}}
 */
const PROPOSAL_STATUS = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  IN_REVIEW: 'IN_REVIEW',
  REVIEWED: 'REVIEWED',
  VALIDATED: 'VALIDATED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  ASSIGNED: 'ASSIGNED',
  ARCHIVED: 'ARCHIVED',
  CANCELED: 'CANCELED',
  DISSOLVED: 'DISSOLVED',
  ON_DISSOLVE_PROCESS: 'ON_DISSOLVE_PROCESS',
  DISMISS: 'DISMISS',
  EXPIRED: 'EXPIRED',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const PROPOSAL_STATUS_ENUM = Object.keys(PROPOSAL_STATUS);

const DRAFT = PROPOSAL_STATUS_ENUM[0];
const SENT = PROPOSAL_STATUS_ENUM[1];
const IN_REVIEW = PROPOSAL_STATUS_ENUM[2];
const REVIEWED = PROPOSAL_STATUS_ENUM[3];
const VALIDATED = PROPOSAL_STATUS_ENUM[4];
const ACCEPTED = PROPOSAL_STATUS_ENUM[5];
const REJECTED = PROPOSAL_STATUS_ENUM[6];
const ASSIGNED = PROPOSAL_STATUS_ENUM[7];
const ARCHIVED = PROPOSAL_STATUS_ENUM[8];
const CANCELED = PROPOSAL_STATUS_ENUM[9];
const DISSOLVED = PROPOSAL_STATUS_ENUM[10];
const EXPIRED = PROPOSAL_STATUS_ENUM[11];

export {
  IN_REVIEW,
  REVIEWED,
  VALIDATED,
  REJECTED,
  ACCEPTED,
  SENT,
  DRAFT,
  PROPOSAL_STATUS_ENUM,
  PROPOSAL_STATUS,
  ASSIGNED,
  ARCHIVED,
  CANCELED,
  DISSOLVED,
  EXPIRED,
};
